import React from 'react';
import styled from 'styled-components';
import { useState, useEffect } from 'react';
import SearchBrandItem from './SearchBrandItem'
import Slider from "react-slick";
import { useDispatch, useSelector } from "react-redux";
import { getBrandAction, getBrandDefaultAction, } from "../../modules/search/searchModule";
import {isEdge, isMobileOnly} from 'react-device-detect';

const SearchBrandListTopBlock = styled.div`
`;

const SearchBrandListTitleH3Block = styled.h3`
    ${isMobileOnly?`
    margin-left: 0px;
    `:`
    
    `};
`;

const SearchBrandListSlideBlock = styled.div`
    ${isEdge?"width: 1177px":(!isMobileOnly?"1176px":"")};
    .slick-track {${isMobileOnly&&"display:flex"}};
`;

const SearchBrandListUlBlock = styled.ul`
margin-left: -28px;
list-style: none;
margin-bottom: 80px;

::after {
    content: '';
    display: block;
    clear: both;
`;

const SearchBrandListLiBlock = styled.li`
margin-top: 0;
position: relative;
float: left;
    //width: 25%;
    //height: 386px;
    //margin-top: 40px;
    //padding-left: 28px;
`;

const SearchBrandListMBlock = styled.div`
width: 100vw;
margin-left: -4vw;

.mobile-brand-conatiner {
    overflow: scroll;
    overflow-y: hidden;
    display: flex;
    padding: 0 0 10px 0;
    //width: max-content;

    .mobile-band:last-child {
        padding-right: 4vw;
    }
    .pd-slider:first-child {
        margin-left: 4vw;
    }
}

`;

const RETRY_COUNT = 3;

const SearchBrandListTop = () => {
    const [reqDefault, setReqDefault] = useState(false);
    const dispatch = useDispatch();
    const [reTryProduct, setReTryProduct] = useState(0);

    const { brandInfo, brandDefaultInfo, errorBrand, errorBrandDefault, searchText, loading, loading2 } = useSelector(
        ({ searchReducer, loadingReducer }) => ({
            brandInfo: searchReducer.brandInfo,
            brandDefaultInfo: searchReducer.brandDefaultInfo,
            errorBrand: searchReducer.errorBrand,
            errorBrandDefault: searchReducer.errorBrandDefault,
            searchText: searchReducer.searchText,
            loading: loadingReducer['search/GET_BRAND'],
            loading2: loadingReducer['search/GET_BRAND_DEFAULT'],
        })
    );

    const settings = {
        dots: false,
        infinite: false,
        // speed: 500,
        // slidesToShow: isMobileOnly?2:5,
        // slidesToScroll: isMobileOnly?1:5,
        variableWidth: true,
        swipeToSlide: true,
        // adaptiveHeight: true
        responsive:[
            {breakpoint:1024,
                settings:{
                    slidesToShow:5,
                    slidesToScroll:5
                }
            },
            {breakpoint:768,
                settings:{
                    slidesToShow:2,
                    slidesToScroll:2
                }
            },
            {breakpoint:350,
                settings:{
                    slidesToShow:2,
                    slidesToScroll:1
                }
            }
        ]
    };
    /* useEffect(() => {
        if (searchText !== null && searchText.length > 0) {
            dispatch(getBrandAction(searchText));
        }
        else {
            dispatch(getBrandDefaultAction());
        }
    }, []) */

    //브랜드 정보 요청 에러나면 3번 재요청
    useEffect(() => {
        if (errorBrand !== null && reTryProduct < RETRY_COUNT) {
            if (searchText !== null && searchText.length > 0) {
                dispatch(getBrandAction(searchText));
            }
            setReTryProduct(reTryProduct + 1);
        }
        else if (errorBrand !== null && reTryProduct === RETRY_COUNT) {
            dispatch(getBrandDefaultAction());
            setReTryProduct(0);
        }
        else {
            setReTryProduct(0);
        }
    }, [errorBrand])

    //디폴트 브랜드 정보 요청 에러나면 3번 재요청
    useEffect(() => {
        if (errorBrandDefault !== null && reTryProduct < RETRY_COUNT) {
            dispatch(getBrandDefaultAction());
            setReTryProduct(reTryProduct + 1);
        }
        else {
            setReTryProduct(0);
        }
    }, [errorBrandDefault])

    useEffect(() => {
        if (searchText !== null && searchText.length > 0) {
            dispatch(getBrandAction(searchText));
        }
        else {
            dispatch(getBrandDefaultAction());
        }
    }, [searchText])

    useEffect(() => {
        if (brandInfo !== null && brandInfo.totalnum === 0) {
            dispatch(getBrandDefaultAction());
            setReTryProduct(0);
        }
    }, [brandInfo])


    /*     if(brandInfo !== null && brandInfo.totalnum === 0 && reqDefault === false){
            dispatch(getBrandDefaultAction());
            setReqDefault(true);
        } */

    /*     if(errorBrand !== null && reqDefault === false) {
            dispatch(getBrandDefaultAction());
            setReqDefault(true);
        } */

    if (brandInfo === null && brandDefaultInfo === null) {
        return <div />
    }

    const getTitle = () => {
        if (brandInfo !== null && brandInfo.totalnum > 0) {
            let stringTitle = "브랜드 ( " + brandInfo.totalnum + " )";
            return stringTitle;
        }

        if (brandDefaultInfo !== null && brandDefaultInfo.length > 0) {
            let stringTitle = "브랜드 모르면 어디?";
            return stringTitle;
        }
    }

    const isIE = () => {
        var ua = navigator.userAgent.toLocaleLowerCase();
        /* MSIE used to detect old browsers and Trident used to newer ones*/
        // console.log("ua = " + ua);
        var is_ie = ua.indexOf("msie ") > -1 || ua.indexOf("trident/") > -1;
        // console.log("is_ie = " + is_ie);
        return is_ie;
    }

    const isEdge = () => {
        var ua = navigator.userAgent.toLocaleLowerCase();
        /* MSIE used to detect old browsers and Trident used to newer ones*/
        // console.log("ua = " + ua);
        var is_edge = ua.indexOf("edge/") > -1;
        // console.log("is_edge = " + is_edge);
        return is_edge;
    }

    const getBrandItemWidth = () => {
        var width = "216px";
        if (isEdge()) {
            width = "213px";
        }
        else if (isIE()) {
            width = "213px";
        }


        return width;
    }

    // const getBrandItemListWidth = () => {
    //     var width = isMobileOnly?"100vw":"1176px";
    //
    //     if (isEdge()) {
    //         width = "1176px";
    //     }
    //     else if (isIE()) {
    //         width = "1177px";
    //     }
    //
    //
    //     return width;
    // }

    const getBrandListMobile = () => {
        if (brandInfo !== null && brandInfo.totalnum > 0) {
            return (
            <SearchBrandListMBlock>
                <div className="mobile-brand-conatiner">
                {
                    brandInfo.dataList.map((brand) => {
                        return (<div key={brand._source.id} className="mobile-band">
                            <SearchBrandItem key={brand._source.id}
                                img_src={brand._source.brnd_logo_url}
                                brndId={brand._source.id}
                                title={brand._source.brnd_han}
                                widthItem={getBrandItemWidth()}
                            />
                        </div>)
                    })
                }
                </div>
            </SearchBrandListMBlock>)
        }

        if (brandDefaultInfo !== null && brandDefaultInfo.length > 0) {
            return (
                <SearchBrandListMBlock>
                    <div className="mobile-brand-conatiner">
                    {
                            brandDefaultInfo.map((brand) => {
                                if (brand.id !== null)
                                    return (<div className="mobile-band">
                                        <SearchBrandItem key={brand.id}
                                            img_src={brand.brnd_logo_url}
                                            brndId={brand.id}
                                            title={brand.brnd_han}
                                            widthItem={getBrandItemWidth()}
                                        />
                                    </div>)
                            })
                        }
                        </div>
                </SearchBrandListMBlock>)

        }
    }

    const getBrandList = () => {
        if (brandInfo !== null && brandInfo.totalnum > 0) {
            if (brandInfo.totalnum < 5) {
                return (
                    <SearchBrandListUlBlock className="search_brand-slide">
                        {
                            brandInfo.dataList.map((brand) => {
                                return (<SearchBrandListLiBlock key={brand._source.id}>
                                    <SearchBrandItem key={brand._source.id}
                                        img_src={brand._source.brnd_logo_url}
                                        brndId={brand._source.id}
                                        title={brand._source.brnd_han}
                                        widthItem={getBrandItemWidth()}
                                    />
                                </SearchBrandListLiBlock>)
                            })
                        }
                    </SearchBrandListUlBlock>
                )
            }
            else {
                return (
                    <SearchBrandListSlideBlock className="search_brand-slide slick-initialized slick-slider">
                        <Slider {...settings}>
                            {
                                brandInfo.dataList.map((brand) => {
                                    return (<SearchBrandItem key={brand._source.id}
                                        img_src={brand._source.brnd_logo_url}
                                        brndId={brand._source.id}
                                        title={brand._source.brnd_han}
                                        widthItem={getBrandItemWidth()}
                                    />)
                                })
                            }
                        </Slider>
                    </SearchBrandListSlideBlock>
                )
            }
        }

        if (brandDefaultInfo !== null && brandDefaultInfo.length > 0) {
            if (brandDefaultInfo.length < 5) {
                return (
                    <SearchBrandListUlBlock className="search_brand-slide">
                        {
                            brandDefaultInfo.map((brand) => {
                                if (brand.id !== null)
                                    return (<SearchBrandListLiBlock>
                                        <SearchBrandItem key={brand.id}
                                            img_src={brand.brnd_logo_url}
                                            brndId={brand.id}
                                            title={brand.brnd_han}
                                            widthItem={getBrandItemWidth()}
                                        />
                                    </SearchBrandListLiBlock>)
                            })
                        }
                    </SearchBrandListUlBlock>
                )
            }
            else {
                return (
                    <SearchBrandListSlideBlock className="search_brand-slide slick-initialized slick-slider">
                        <Slider {...settings}>
                            {
                                brandDefaultInfo.map((brand) => {
                                    if (brand.id !== null)
                                        return (<SearchBrandItem key={brand.id}
                                            img_src={brand.brnd_logo_url}
                                            brndId={brand.id}
                                            title={brand.brnd_han}
                                            widthItem={getBrandItemWidth()}
                                        />)
                                })
                            }
                        </Slider>
                    </SearchBrandListSlideBlock>
                )
            }
        }
    }
    return (
        <SearchBrandListTopBlock className="default-table">
            <SearchBrandListTitleH3Block className="dt-title margin_l-20">
                {getTitle()}
            </SearchBrandListTitleH3Block>
            {isMobileOnly? getBrandListMobile() : getBrandList()}
        </SearchBrandListTopBlock>

    );
};

export default SearchBrandListTop;
